/* eslint-disable no-console */
import { Box, Button, Container, Flex, Image, Text, Textarea } from '@chakra-ui/react'
import NavbarOpen from '../NavLinks/NavbarOpen'
import { useParams } from 'react-router-dom'
import { useCallback, useEffect, useState } from 'react'
import { addComment, getMeetData } from '../../Api/meetings'
import { formatMeeting } from '../Meetings2/Meetings'
import { DateTime } from 'luxon'

const VCComments = () => {
  const { eventId } = useParams()
  const [eventData, setEventData] = useState()
  const [loading, setLoading] = useState(false)
  const [added, setAdded] = useState(false)

  const [comment, setComment] = useState('')

  useEffect(() => {
    // eslint-disable-next-line no-console
    console.log(eventId)
  }, [eventId])

  const getData = useCallback(async () => {
    const data = await getMeetData(eventId)
    console.log('d', data)
    const eventData = formatMeeting(data, [])
    

    const dateTime = DateTime.fromObject({
      year: parseInt(eventData.day.year),
      month: parseInt(DateTime.fromFormat(eventData.day.month, 'LLLL').toFormat('L')),
      day: parseInt(eventData.day.date),
      hour: parseInt(DateTime.fromFormat(eventData.time, 'hh:mm a').toFormat('H')),
      minute: parseInt(DateTime.fromFormat(eventData.time, 'hh:mm a').toFormat('m')),
    })
    
    const duration = parseInt(eventData.duration)*60000
    const endTime = DateTime.fromMillis(dateTime.toMillis() + duration).toFormat('hh:mm a')

    setEventData({...eventData, endTime})
  }, [])

  const handleAddComment = async () => {
    if (added || loading) return
    if (!eventData.eventId || !comment) return

    setLoading(true)
    await addComment(eventData.eventId, comment)
    setComment('')
    setAdded(true)
    setLoading(false)
  }

  useEffect(() => {
    if (eventId) {
      getData()
    }
  }, [eventId])

  return (
    <Container bg='brandBackground' maxW='full' px='157px' pt='48px' h='100vh'>
      <Box left='0' top='0' position='absolute'>
        <NavbarOpen />
      </Box>

      <Container
        maxW='full'
        w='full'
        mr={0}
        display='flex'
        flexDirection='column'
        h='full'
        py='56px'
      >
        
        <Text
          color='#3C3C3C'
          fontFamily='Raleway'
          fontStyle='normal'
          fontWeight='800'
          fontSize='50px'
          lineHeight='60px'
        >
          {eventData?.title}
        </Text>
        <Flex mt='18px'>
          {eventData ? (
            <Text
              color='#89929B'
              fontFamily='Inter'
              fontStyle='normal'
              fontWeight='500'
              fontSize='16px'
              lineHeight='22px'
            >
              {eventData?.day.day}&nbsp;
              {eventData?.day.date}&nbsp;
              {eventData?.day.month}&nbsp;
            at&nbsp;
              {eventData?.time}
            &nbsp;-&nbsp;
              {eventData?.endTime}&nbsp;
            </Text>
          ): <></>}
        </Flex>

        <Flex mt='18px' alignItems='center'>
          {eventData?<Image boxSize={4} mr={3} src='/assets/icons/people_comments.svg' />:<></>}
          <Text
            color='#89929B'
            fontFamily='Inter'
            fontStyle='normal'
            fontWeight='500'
            fontSize='16px'
            lineHeight='22px'
          >
            
            {eventData?.attendees.split(',').join(', ')}
          </Text>
        </Flex>
        
        <Flex mt='75px' flexDirection='column' alignItems='center'>
          
          {added ? (
            <Text
              color='#6E6E6E'
              fontFamily='Raleway'
              fontStyle='normal'
              fontWeight='600'
              fontSize='25px'
              lineHeight='29px'
              mt='32px'
            >
              Great - your comment has been added to your Arrowhead table!
            </Text>
          ): (
            <Text
              color='#6E6E6E'
              fontFamily='Raleway'
              fontStyle='normal'
              fontWeight='600'
              fontSize='25px'
              lineHeight='29px'
            >
            What are your thoughts?
            </Text>
          )}

          {!added ? (
            <>
              <Textarea
                mt='23px'
                minH={0}
                maxH='100%'
                maxW='943px'
                rows={8}
                height='auto'
                resize='none'
                _focusVisible={{outline: 'none'}}
                border='1px solid #000000' 
                boxShadow='0px 4px 4px rgba(0, 0, 0, 0.25)' 
                borderRadius='6.5px' 
                color='black'
                p={6}
                _placeholder={{color: 'rgba(0, 0, 0, 0.4)'}}
                placeholder='Put your point of view here - Should this startup go to the next round of conversations? Why or why not?'
                value={comment}
                onChange={(e) => setComment(e.target.value)}
                // onKeyDown={(event) => {
                //   if (event.key === 'Enter') {
                //     event.preventDefault()
                //     handleAddComment()
                //   }
                // }}
              />

              <Button isActive={!loading && !added} onClick={() => handleAddComment()} mt={8} mb={8} _active={{background: 'black'}} background='rgba(0,0,0,0.3)' _hover={{background: !loading && !added ? 'rgba(0,0,0,0.8)' : 'rgba(0,0,0,0.3)'}}>
                {added ? (
                  'Added'
                ): (
                  <>
                Submit
                    <Image boxSize='22px' ml={2} src='/assets/icons/enter_key.svg' />
                  </>
                )}
              </Button>  
            </>
          ) : <></>}
          
        </Flex>

      </Container>
    </Container>
  )
}

export default VCComments